"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Clock, Leaf, ShieldCheck } from "lucide-react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const features = [{
  icon: ShieldCheck,
  title: "VERIFIED PROS",
  description: "Every contractor joins through network onboarding. Connect with independent local specialists ready to handle your home repairs and installations."
}, {
  icon: Leaf,
  title: "QUALITY SERVICE",
  description: "Connect with pros experienced in residential heating and cooling. Your pro provides clear upfront estimates to keep your home comfortable."
}, {
  icon: Clock,
  title: "FAST BOOKING",
  description: "Request service in seconds. Connect directly with local pros for clear communication and prompt scheduling for every job."
}];
export default function Servicehighlights() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add({
      reduce: "(prefers-reduced-motion: reduce)",
      motion: "(prefers-reduced-motion: no-preference)"
    }, context => {
      const conditions = context.conditions as {
        reduce: boolean;
        motion: boolean;
      };
      if (conditions.reduce) {
        gsap.set([".protocol-eyebrow", ".protocol-heading", ".protocol-lede", ".protocol-col", ".protocol-divider"], {
          opacity: 1,
          y: 0,
          scaleX: 1
        });
        return;
      }
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top 85%"
        },
        defaults: {
          ease: "cubic-bezier(0.22, 0.61, 0.36, 1)",
          duration: 0.52
        }
      });
      tl.from(".protocol-eyebrow", {
        opacity: 0,
        y: 16
      }).from(".protocol-heading", {
        opacity: 0,
        y: 16
      }, "-=0.43").from(".protocol-lede", {
        opacity: 0,
        y: 16
      }, "-=0.43").from(".protocol-divider", {
        scaleX: 0,
        transformOrigin: "left center",
        duration: 0.48,
        ease: "cubic-bezier(0.4, 0, 0.2, 1)",
        stagger: 0.09
      }, "-=0.35").from(".protocol-col", {
        opacity: 0,
        y: 16,
        stagger: 0.09
      }, "-=0.55");
    });
  }, {
    scope: container
  });
  return <section data-section-id="24667" id="servicehighlights" data-nav="light" ref={container} className="bg-background py-24 md:py-32 lg:py-40 text-foreground">
      <div className="mx-auto max-w-[1440px] px-5 md:px-8 lg:px-12">
        {}
        <div className="max-w-[calc((100%/12)*7)] md:max-w-[58%]">
          <div className="protocol-eyebrow flex items-center gap-3">
            <span aria-hidden="true" className="inline-block h-3 w-[1.5px]" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="font-default text-xs font-semibold uppercase leading-none" style={{
            letterSpacing: "0.18em",
            color: "var(--primary)"
          }}>
              Our Standards
            </span>
            <span aria-hidden="true" className="inline-block h-3 w-[1.5px]" style={{
            backgroundColor: "var(--primary)"
          }} />
          </div>

          <h2 className="protocol-heading mt-6 font-default font-bold uppercase text-foreground" style={{
          fontSize: "clamp(2.25rem, 5.4vw, 4.75rem)",
          lineHeight: "0.94",
          letterSpacing: "-0.005em"
        }}>
            {"Trusted home care."}
          </h2>

          <p className="protocol-lede mt-8 max-w-[520px] font-default text-muted-foreground" style={{
          fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
          lineHeight: "1.55"
        }}>
            {"Reliable service for every home project."}
          </p>
        </div>

        {}
        <div className="mt-16 grid grid-cols-1 gap-12 md:mt-20 md:grid-cols-3 md:gap-10">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className="protocol-col flex flex-col">
                <div className="protocol-divider h-px w-full" style={{
              backgroundColor: "var(--border)"
            }} />
                <div className="pt-8">
                  <Icon className="text-primary" strokeWidth={1.5} width={40} height={40} aria-hidden="true" />
                  <h3 className="mt-8 font-default font-bold uppercase text-foreground" style={{
                fontSize: "clamp(1.5rem, 2.4vw, 2.125rem)",
                lineHeight: "1.05",
                letterSpacing: "0"
              }}>
                    {feature.title}
                  </h3>
                  <p className="mt-5 font-default text-muted-foreground" style={{
                fontSize: "clamp(1rem, 1.05vw, 1.0625rem)",
                lineHeight: "1.6"
              }}>
                    {feature.description}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}